import React, { useState } from "react";
import { useTheme } from "styled-components";
import { Box } from "../../Box";
import { zIndex } from "../../../styled_components";
/**
 * An animated (fade in/out) background for the modal
 * @param {React.ReactNode} children the modal to render on top of the background
 * @param {number} zIndexOverride the z-index to use for the modal overlay. If not provided, the default zIndex() function will be used.
 * @returns a react component
 */
export const ModalOverlay = ({ zIndexOverride, children, onClose, modalOverlayHeight }) => {
    const [isMouseDown, setIsMouseDown] = useState(false);
    const { colors: { modalColors }, } = useTheme();
    const closeModal = (event) => {
        if (isMouseDown && event.target === event.currentTarget) {
            onClose(event);
        }
    };
    // Make sure pointerDown happens on the overlay because click is fired in Chrome when you just pointerUp
    // https://github.com/jquense/react-bootstrap-modal/issues/63
    const onPointerDown = (event) => {
        if (event.target === event.currentTarget) {
            setIsMouseDown(true);
        }
    };
    return (React.createElement(Box, { alignItems: "flex-start", backgroundColor: modalColors.overlay, bottom: 0, display: "flex", "data-testid": "modalOverlay", justifyContent: "center", onClick: closeModal, onPointerDown: onPointerDown, left: 0, overflow: "auto", padding: 4, position: "fixed", right: 0, top: 0, zIndex: zIndexOverride || zIndex(), height: modalOverlayHeight }, children));
};
